// ./src/config/connectorCategories.ts
export const CONNECTOR_CATEGORIES = {
  WEBHOOKS: "WEBHOOKS",
  DATA_STORAGE: "DATA_STORAGE",
  FILES_STORAGE: "FILES_STORAGE",
  MESSENGERS: "MESSENGERS",
  CRM: "CRM",
  PRODUCTIVITY: "PRODUCTIVITY",
  EMAIL: "EMAIL",
};

export const CONNECTOR_TYPES = {
  HTTP: "HTTP",
  FTP: "FTP",
  FTPS: "FTPS",
  AZURE_STORAGE_ACCOUNT_BLOB: "AZURE_STORAGE_ACCOUNT_BLOB",
  AZURE_STORAGE_ACCOUNT_QUEUE: "AZURE_STORAGE_ACCOUNT_QUEUE",
  AZURE_STORAGE_ACCOUNT_TABLE: "AZURE_STORAGE_ACCOUNT_TABLE",
  AZURE_SERVICE_BUS: "AZURE_SERVICE_BUS",
  AZURE_EVENT_GRID: "AZURE_EVENT_GRID",
  AWS_S3: "AWS_S3",
  AWS_SQS: "AWS_SQS",
  AWS_SNS: "AWS_SNS",
  AWS_EVENTBRIDGE: "AWS_EVENTBRIDGE",
  AWS_DYNAMODB: "AWS_DYNAMODB",
  GCP_STORAGE: "GCP_STORAGE",
  GCP_PUBSUB: "GCP_PUBSUB",
  GCP_FIRESTORE: "GCP_FIRESTORE",
  SLACK: "SLACK",
  TELEGRAM: "TELEGRAM",
  DISCORD: "DISCORD",
  HUBSPOT: "HUBSPOT",
  GOOGLE_SHEETS: "GOOGLE_SHEETS",
  NOTION: "NOTION",
  AIRTABLE: "AIRTABLE",
  TRELLO: "TRELLO",
  GITHUB: "GITHUB",
  MAILCHIMP: "MAILCHIMP",
  CONVERTKIT: "CONVERTKIT",
  SENDGRID: "SENDGRID",
  SMTP: "SMTP",
  AWS_SES: "AWS_SES",
};

export const CONNECTOR_CATEGORY_LABELS: Record<string, string> = {
  [CONNECTOR_CATEGORIES.WEBHOOKS]: "Webhooks",
  [CONNECTOR_CATEGORIES.DATA_STORAGE]: "Data Storage",
  [CONNECTOR_CATEGORIES.FILES_STORAGE]: "Files Storage",
  [CONNECTOR_CATEGORIES.MESSENGERS]: "Messengers",
  [CONNECTOR_CATEGORIES.CRM]: "CRM",
  [CONNECTOR_CATEGORIES.PRODUCTIVITY]: "Productivity",
};

export const CONNECTOR_TYPE_LABELS: Record<string, string> = {
  [CONNECTOR_TYPES.HTTP]: "HTTP",
  [CONNECTOR_TYPES.FTP]: "FTP",
  [CONNECTOR_TYPES.FTPS]: "FTPS",
  [CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_BLOB]: "Azure Storage Account Blob",
  [CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_QUEUE]: "Azure Storage Account Queue",
  [CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_TABLE]: "Azure Storage Account Table",
  [CONNECTOR_TYPES.AZURE_SERVICE_BUS]: "Azure ServiceBus",
  [CONNECTOR_TYPES.AZURE_EVENT_GRID]: "Azure Event Grid",
  [CONNECTOR_TYPES.AWS_S3]: "AWS S3",
  [CONNECTOR_TYPES.AWS_SQS]: "AWS SQS",
  [CONNECTOR_TYPES.AWS_SNS]: "AWS SNS",
  [CONNECTOR_TYPES.AWS_EVENTBRIDGE]: "AWS EventBridge",
  [CONNECTOR_TYPES.AWS_DYNAMODB]: "AWS DynamoDB",
  [CONNECTOR_TYPES.GCP_STORAGE]: "GCP Storage",
  [CONNECTOR_TYPES.GCP_PUBSUB]: "GCP PubSub",
  [CONNECTOR_TYPES.GCP_FIRESTORE]: "GCP Firestore",
  [CONNECTOR_TYPES.SLACK]: "Slack",
  [CONNECTOR_TYPES.TELEGRAM]: "Telegram",
  [CONNECTOR_TYPES.DISCORD]: "Discord",
  [CONNECTOR_TYPES.HUBSPOT]: "HubSpot",
  [CONNECTOR_TYPES.GOOGLE_SHEETS]: "Google Sheets",
  [CONNECTOR_TYPES.NOTION]: "Notion",
  [CONNECTOR_TYPES.AIRTABLE]: "Airtable",
  [CONNECTOR_TYPES.TRELLO]: "Trello",
  [CONNECTOR_TYPES.GITHUB]: "GitHub",
  [CONNECTOR_TYPES.MAILCHIMP]: "MailChimp",
  [CONNECTOR_TYPES.CONVERTKIT]: "Kit (formerly ConvertKit)",
  [CONNECTOR_TYPES.SENDGRID]: "Twilio SendGrid",
  [CONNECTOR_TYPES.AWS_SES]: "Amazon SES",
};

export const CONNECTOR_CATEGORY_TO_TYPES = {
  [CONNECTOR_CATEGORIES.WEBHOOKS]: [CONNECTOR_TYPES.HTTP],
  [CONNECTOR_CATEGORIES.DATA_STORAGE]: [
    CONNECTOR_TYPES.FTP,
    CONNECTOR_TYPES.FTPS,
    CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_BLOB,
    CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_QUEUE,
    CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_TABLE,
    CONNECTOR_TYPES.AZURE_SERVICE_BUS,
    CONNECTOR_TYPES.AZURE_EVENT_GRID,
    CONNECTOR_TYPES.AWS_S3,
    CONNECTOR_TYPES.AWS_SQS,
    CONNECTOR_TYPES.AWS_SNS,
    CONNECTOR_TYPES.AWS_EVENTBRIDGE,
    CONNECTOR_TYPES.AWS_DYNAMODB,
    CONNECTOR_TYPES.GCP_STORAGE,
    CONNECTOR_TYPES.GCP_PUBSUB,
    CONNECTOR_TYPES.GCP_FIRESTORE,
  ],
  [CONNECTOR_CATEGORIES.FILES_STORAGE]: [
    CONNECTOR_TYPES.FTP,
    CONNECTOR_TYPES.FTPS,
    CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_BLOB,
    CONNECTOR_TYPES.AWS_S3,
    CONNECTOR_TYPES.GCP_STORAGE,
  ],
  [CONNECTOR_CATEGORIES.MESSENGERS]: [
    CONNECTOR_TYPES.SLACK,
    CONNECTOR_TYPES.TELEGRAM,
    CONNECTOR_TYPES.DISCORD,
  ],
  [CONNECTOR_CATEGORIES.CRM]: [CONNECTOR_TYPES.HUBSPOT],
  [CONNECTOR_CATEGORIES.PRODUCTIVITY]: [
    CONNECTOR_TYPES.GOOGLE_SHEETS,
    CONNECTOR_TYPES.NOTION,
    CONNECTOR_TYPES.AIRTABLE,
    CONNECTOR_TYPES.TRELLO,
    CONNECTOR_TYPES.GITHUB,
    CONNECTOR_TYPES.MAILCHIMP,
    CONNECTOR_TYPES.CONVERTKIT,
  ],
  [CONNECTOR_CATEGORIES.EMAIL]: [
    CONNECTOR_TYPES.SENDGRID,
    CONNECTOR_TYPES.SMTP,
    CONNECTOR_TYPES.AWS_SES,
  ],
};

export const FILE_STORAGE_CONNECTOR_TYPES = [
  CONNECTOR_TYPES.FTP,
  CONNECTOR_TYPES.FTPS,
  CONNECTOR_TYPES.AZURE_STORAGE_ACCOUNT_BLOB,
  CONNECTOR_TYPES.AWS_S3,
  CONNECTOR_TYPES.GCP_STORAGE,
];
